
const patientRoutes = [
    {
        path:'list',
        name:'patient-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/patient/list.vue')
    },
    {
        path:'info',
        name:'patient-info',
        component: () => import(/* webpackChunkName: "about" */ '../views/patient/info.vue')
    },
]
export default patientRoutes